<script>

  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  export let label = ""
  export let placeholder = ""
  export let value = label
  export let labelStyle = ""
  export let labelIcon = ""
  export let labelIconHeight = "18px"
  export let beforeInputText = ""
  export let afterInputText = ""
  export let minInputWidth = "0px"
  export let disabled = false

  let labelEl
  let inputEl
  let beforeInputTextEl
  let afterInputTextEl


  function showInput() {
    if (disabled==false) {
      let labelLen = labelEl.offsetWidth
      labelLen = Math.max(labelLen, parseInt(minInputWidth,10) )
      labelEl.style.display="none"
      inputEl.style.display="inline-block"
      beforeInputTextEl.style.display="inline-block"
      afterInputTextEl.style.display="inline-block"
      inputEl.style.width = labelLen+"px"
      inputEl.focus()
      inputEl.select()
    }
  }

  function showLabel() {
    labelEl.style.display="inline-block"
    inputEl.style.display="none"
    beforeInputTextEl.style.display="none"
    afterInputTextEl.style.display="none"
  }

  function mychange() {
    dispatch('mychange', {
      value: value
    });
    showLabel();
  }


</script>

<span style="text-align:right;">

  <span
    bind:this={labelEl}
    class={disabled ? "span" : "span underlined"}
    style={labelStyle}
    on:click={showInput}
  >
  {#if labelIcon}
    <img src={labelIcon} alt="Icon for label" style="vertical-align:middle; height: {labelIconHeight}">
  {/if}
  {#if label}
    {label}
  {/if}
  </span>

  <span bind:this={beforeInputTextEl} style="display:none">
    {#if beforeInputText}{beforeInputText}{/if}
  </span>

  <input
    bind:this={inputEl}
    class="input"
    style="min-width: {minInputWidth}"
    type="text"
    placeholder={placeholder}
    bind:value={value}
    on:change={mychange}
    on:blur={showLabel}
    >

    <span bind:this={afterInputTextEl} style="display:none">
    {#if afterInputText}
      {afterInputText}
    {/if}
    </span>


</span>


<style>
  .span {
    display: inline-block;
    margin:0;
  }
  .underlined {
    text-decoration: underline dotted black;
  }

  .input {
      display: none;
      border: none;
      border-bottom: 1px solid black;
      padding: 0;
  }

</style>
